<template>
    <main :class="{ 'main': true, 'with-sidebar': true, 'locked': showModal }">
        <div class="container employees">

            <div v-if="visible">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-header">
                            <span class="button-full" @click="toggleModal">{{ $t('button.add') }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="width-6">{{ $t('label.person_name') }}</th>
                                <th id="_phone" class="width-3">{{ $t('label.phone') }}</th>
                                <th class="width-3"></th>
                            </tr>
                            </thead>
                            <tbody v-if="!employees.length">
                                <tr>
                                    <td colspan="3">{{ $t('label.noDataAvailable') }}</td>
                                </tr>
                            </tbody>
                            <draggable :element="'tbody'"
                                       :v-model="employees"
                                       :list="employees"
                                       :options="{handle:'.table-sortable', group:'employees'}"
                                       @update="onUpdate"
                                       v-else>
                                <tr v-for="(employee, index) in employees" :key="employee.order">
                                    <td><employee-cell :rowData="employee" :rowIndex="index"></employee-cell></td>
                                    <td class="table-cell-hide"><a :href="'tel:' + employee.phone">{{ employee.phone }}</a></td>
                                    <td class="table-controls"><employee-actions :rowData="employee" :rowIndex="index"></employee-actions></td>
                                </tr>
                            </draggable>
                        </table>
                    </div>
                </div>
                <employee-modal :data="employee" :show="showModal" @closed="onClosed"></employee-modal>
            </div>
			
        </div>
    </main>
</template>
<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import EmployeeCell from './EmployeeCell'
  import EmployeeActions from './EmployeeActions'
  import EmployeeModal from './EmployeeModal'
  import Draggable from 'vuedraggable'

  Vue.component('employee-cell', EmployeeCell)
  Vue.component('employee-actions', EmployeeActions)

  export default {
    name: 'Employees',
    components: {
      EmployeeCell,
      EmployeeModal,
      Draggable
    },
    data () {
      return {
        visible: false,
        url: '/v1/employees/',
        showModal: false,
        employee: {},
        employees: []
      }
    },
    created () {
      this.getEmployees()
    },
    mounted () {
      this.$events.$on('employee-edited', eventData => this.onEdit(eventData))
      this.$events.$on('employee-deleted', eventData => this.onDelete(eventData))
    },
    methods: {
      getEmployees () {
        this.$api.get('/v1/employees').then(response => {
          this.employees = _.orderBy(response.data.data, 'order')
          this.visible = true
        }).catch((error) => {
          console.error(error)
        })
      },
      toggleModal () {
        this.showModal = !this.showModal
      },
      onUpdate () {
        let positions = {}
        for (let key in this.employees) {
          positions[key] = this.employees[key].id
        }
        this.$api.post('/v1/employees/sort', {order: positions}).then(() => {
        }).catch((error) => {
          console.error(error)
        })
      },
      onDelete (data) {
        this.getEmployees()
      },
      onEdit (data) {
        this.employee = _.cloneDeep(data.employee)
        this.showModal = true
      },
      onClosed (data) {
        if (data.updated) {
          this.getEmployees()
        }
        this.showModal = data.show
      },
      onTableLoaded () {
        this.visible = true
      },
      createFormData () {
        let data = []
        data['name'] = this.employee.name
        data['phone'] = this.employee.phone
        data['status'] = this.employee.status
        let formData = new FormData()

        for (let entry in data) {
          if (data[entry] === null || typeof data[entry] === 'undefined') {
            continue
          }
          formData.append(entry, data[entry])
        }

        return formData
      }
    },
    destroyed () {
      this.$events.off('employee-edited')
      this.$events.off('employee-deleted')
      this.$events.off('employee-created')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Employees/Employees.vue